import { Link } from 'react-router-dom';
import { trendingKeywords } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20dark%20atmospheric%20background%20with%20warm%20amber%20and%20deep%20red%20gradients%20soft%20film%20grain%20texture%20cinematic%20mood%20editorial%20photography%20dramatic%20lighting%20with%20subtle%20geometric%20patterns%20elegant%20composition&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="91在线视频 - 网红黑料吃瓜爆料与热门事件追踪"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 pt-24 pb-16">
        <div className="w-full max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            <span className="text-xs text-background-50/90">实时热搜 · 7x24小时追踪</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-5">
            全网最热
            <br />
            <span className="text-primary-400">吃瓜爆料</span>第一站
          </h1>

          <p className="text-base md:text-lg text-background-50/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            网红黑料、热门事件、独家爆料，全网最新最全的娱乐资讯平台。下载91在线视频APP，吃瓜快人一步。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/chigua-baoliao"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-label font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
            </Link>
            <a
              href="#app-download"
              className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-label font-semibold text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              下载APP
            </a>
          </div>

          <div className="mt-14 flex flex-wrap items-center justify-center gap-2">
            {trendingKeywords.slice(0, 8).map((keyword) => (
              <Link
                key={keyword}
                to={`/category/remen-shijian`}
                className="px-4 py-1.5 rounded-full bg-background-50/10 backdrop-blur-sm text-xs text-background-50/80 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                #{keyword}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pb-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center gap-2">
            <span className="text-xs text-background-50/50">向下滚动探索更多</span>
            <i className="ri-arrow-down-line text-background-50/50 animate-bounce"></i>
          </div>
        </div>
      </div>
    </section>
  );
}